// ListGrid.js
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { FaCalendarAlt } from "react-icons/fa";

// Outer container
const Container = tw.div`
  max-w-screen-md 
  mx-auto 
  px-4 
  py-8 
  text-gray-800 
  leading-relaxed
`;

// Date selection row
const FilterRow = tw.div`
  mb-6 
  flex 
  flex-col 
  sm:flex-row 
  sm:items-center 
  sm:space-x-4 
  space-y-2 
  sm:space-y-0
`;

const Label = tw.span`
  text-xl 
  font-semibold
`;

const Select = tw.select`
  border 
  border-gray-300 
  rounded 
  px-3 
  py-2 
  text-sm 
  focus:outline-none 
  focus:ring-2 
  focus:ring-primary-400
`;

// Wrapper for the entire list of items
const ListWrapper = tw.div`
  flex 
  flex-col 
  space-y-4
`;

/*
  Card styling (Horizontal layout)
*/
const Card = styled.div`
  ${tw`
    flex
    items-stretch
    bg-primary-100
    text-black
    border
    cursor-pointer
    transition-transform
    duration-300
    hover:scale-105
    overflow-hidden
  `}
  border-top-left-radius: 2rem;
  border-bottom-right-radius: 2rem;
`;

/*
  LeftBg: Background image container
*/
const LeftBg = styled.div`
  ${tw`w-32 sm:w-48 flex-shrink-0`}
  background-image: url("${(props) => props.imageSrc}");
  background-size: cover;
  background-position: center;
`;

// Text container (Right side)
const CardContent = tw.div`
  flex-1 
  p-4
`;

const Title = tw.h3`text-xl font-bold mb-2`;
const IconWithText = tw.div`flex items-center pb-3 mr-6 my-2 sm:my-0`;
const IconContainer = styled.div`
  ${tw`inline-block rounded-full p-2 bg-gray-700 text-gray-100`}
  svg {
    ${tw`w-3 h-3`}
  }
`;
const Text = tw.div`ml-2 text-sm font-semibold text-gray-800`;
const Description = tw.p`text-sm text-gray-700`;

export default function ListGrid({ items = [], showDateFilter = false, onFilterChange, onItemClick }) {
  const [selectedYear, setSelectedYear] = useState("2025");
  const years = ["2025", "2024", "2023", "2022", "2021", "2020"];

  const handleYearChange = (e) => {
    const newYear = e.target.value;
    setSelectedYear(newYear);
    if (onFilterChange) {
      onFilterChange(newYear);
    }
  };

  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear().toString();
    setSelectedYear(currentYear);
  }, []);

  return (
    <Container>
      {/* Tarih Seçiniz alanı */}
      {showDateFilter && (
        <FilterRow>
          <Label>Tarih Seçiniz</Label>
          <Select value={selectedYear} onChange={handleYearChange}>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </Select>
        </FilterRow>
      )}

      <ListWrapper>
        {items.map((item, idx) => (
          <Card key={idx} onClick={() => onItemClick?.(item)}>
            {/* Left portion as a background image */}
            {item.image && <LeftBg imageSrc={item.image} />}
            {/* Text on the right */}
            <CardContent>
              {item.title && <Title>{item.title}</Title>}
              {item.date && (
                <IconWithText>
                  <IconContainer>
                    <FaCalendarAlt />
                  </IconContainer>
                  <Text>{item.date}</Text>
                </IconWithText>
              )}
              {item.description && <Description>{item.description}</Description>}
            </CardContent>
          </Card>
        ))}
      </ListWrapper>
    </Container>
  );
}
